import { Colors } from "@themes/colors";

type DataBarChartElement = {
  month: string;
  value: number;
};

export const dataBarChart: Array<DataBarChartElement> = [
  {
    month: "01/21",
    value: 0,
  },
  {
    month: "02/21",
    value: 20,
  },
  {
    month: "03/21",
    value: 5,
  },
  {
    month: "04/21",
    value: 12,
  },
  {
    month: "05/21",
    value: 13,
  },
  {
    month: "06/21",
    value: 9,
  },
  {
    month: "07/21",
    value: 6,
  },
  {
    month: "08/21",
    value: 3,
  },
  {
    month: "09/21",
    value: 13,
  },
  {
    month: "10/21",
    value: 15,
  },
  {
    month: "11/21",
    value: 10,
  },
  {
    month: "12/21",
    value: 8,
  },
];

type DataPieChartElement = {
  name: string;
  value: number;
  color: string;
};

export const dataPieChart: Array<DataPieChartElement> = [
  {
    name: "Typologie 1",
    value: 72,
    color: Colors.primary,
  },
  {
    name: "Typologie 2",
    value: 28,
    color: Colors.error,
  },
  {
    name: "Typologie 3",
    value: 14,
    color: Colors.info,
  },
  {
    name: "Typologie 4",
    value: 36,
    color: Colors.purple,
  },
];
